module.exports = __webpack_public_path__ + "static/marchi-fresche-bonta-8606e3533dbadd22e4fcb29a3589930a.jpg";